import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import logo from "../../Assets/images/logo/Inaipi_Logo.png";
import {
  TbUserExclamation,
  TbSquareRoundedX,
  TbUserCheck,
  TbCircleDotFilled,
} from "react-icons/tb";
import { MdFileDownloadDone } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import {
  IoArrowBack,
  IoNotificationsOutline,
  IoNotificationsOffOutline,
} from "react-icons/io5";
import {
  Bell,
  CaretRight,
  SealCheck,
  SignOut,
  ArrowsClockwise,
  Numpad,
  PersonSimpleRun,
  EnvelopeSimple,
} from "@phosphor-icons/react";

// mui
import {
  Divider,
  CardActions,
  CardContent,
  AppBar,
  Avatar,
  Box,
  Chip,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Badge,
  Popover,
  Button,
  Card,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
// Other
import {
  closeNotify,
  clearnotifyAll,
  setshowphonedialer,
  setShowingStatusClass,
  setShowingStatus,
  setShowingStatusVoice,
  setReadyButton,
  updateNotification,
  setVoiceAvailable,
} from "../../Redux/Actions/actions";
import moment from "moment";
import {
  ACCS_Report,
  BaseUrl,
  Bulk_SMS,
  CMS,
  logoutTime,
  Survey,
  versionCode,
  PortalUrl,
} from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import ChangesPasswordModel from "./ChangesPasswordModel";
import { toaststyle } from "../../Utils/toaststyle";
import { useNavigate } from "react-router-dom";
import { IoIosLink } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const StyledPopover = styled(Popover)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "7px",
  },
}));

const theme = createTheme({
  typography: {
    button: {
      fontSize: "12px",
      fontWeight: 600,
      boxShadow: "none",
    },
  },
  button: {
    boxShadow: "none",
  },
});

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  lineHeight: "20px",
  padding: "5px 10px",
  marginBottom: "3px",
  background: "white",
  boxShadow: "none",
  transition: "transform 0.3s ease",
  display: "flex",
  alignItems: "center",
  fontSize: "13px",

  "&.MuiPaper-root": {
    borderRadius: "7px",
    color: "rgba(0, 0, 0, 0.6)",
    "&:hover": {
      background: "#1473e6",
      cursor: "pointer",
      color: "white",
    },
    "&:active": {
      background: "#0b3363",
      cursor: "pointer",
      color: "white",
      transform: "scale(0.99)",
    },
  },
}));

const getUserNameOnNavbar = () => {
  const UserName = JSON.parse(localStorage.getItem("tokenAgent")).username;
  try {
    let first = UserName.split(" ")[0].slice(0, 1);
    let second = UserName.split(" ")[1].slice(0, 1);
    return first + second;
  } catch (error) {
    return UserName.split(" ")[0].slice(0, 1);
  }
};

const getEmailOnNavbar = () => {
  return JSON.parse(localStorage.getItem("tokenAgent")).email;
};

const mapStateToProps = (state) => {
  return {
    notification: state.notification.notification,
    showphonedialer: state.voice.showphonedialer,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    showingStatusClass: state.contactListData.showingStatusClass,
    voiceAvailable: state.contactListData.voiceAvailable,
    voicePlatForm: state.contactListData.voicePlatForm,
    callList: state.voice.callList,
  };
};

const Navbar = (props) => {
  const {
    showingStatus,
    readyButton,
    showingStatusVoice,
    aesSocket,
    isAesReadyReload,
    setIsAesLoginReload,
  } = props;
  let permission = JSON.parse(localStorage.getItem("permission"));
  const AvcUrl = localStorage.getItem("AvcUrl");
  const navigate = useNavigate();
  const LoggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const userName = JSON.parse(localStorage.getItem("tokenAgent"));
  const [goReadyButtonDisable, setgoReadyButtonDisable] = useState(false);
  const [showReasonCode, setshowReasonCode] = useState(false);
  const [userstatus, setUserstatus] = useState([]);
  const [openChangePasswordModel, setopenChangePasswordModel] = useState(false);

  const [spinner, setspinner] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [showportallink, setShowportallink] = useState(false);
  const [portalLinkList, setPortalLinkList] = useState({});

  const handleCloseportal = () => setShowportallink(false);
  const handleShowportal = () => setShowportallink(true);

  const portalLinksDatas = [
    {
      title: "BULK SMS",
      screenId: "BULK_SMS",
      hoverCard: "bulkSms",
      url: portalLinkList.Bulk_SMS,
    },
    {
      title: "CMS",
      screenId: "CMS",
      hoverCard: "cms",
      url: portalLinkList.CMS,
    },
    {
      title: "SURVEY",
      screenId: "SURVEY",
      hoverCard: "survey",
      url: portalLinkList.Survey,
    },
    {
      title: "ACCS REPORT",
      screenId: "ACCS_REPORT",
      hoverCard: "accsReport",
      url: portalLinkList.ACCS_Report,
    },
    {
      title: "RECORDING ACCESS",
      screenId: "RECORDING_ACCESS",
      hoverCard: "Recording",
      url: portalLinkList.Recording_Link,
    },
  ];

  const getPortalLinksVal = portalLinksDatas.filter((items) =>
    permission.some((module) => {
      if (module.moduleName === "NAVBAR") {
        return module.screen.some(
          (screen) =>
            screen.screenId === items.screenId && screen.read && screen.write
        );
      }
      return false;
    })
  );
  const voicelogin=async()=>{
    axios
    .post(
      AvcUrl +
        `/voice/cct/login?username=${localStorage.getItem(
          "AvayaUsername"
        )}&password=${localStorage.getItem(
          "AvayaPassword"
        )}&domain=${localStorage.getItem("AvayaDomain")}`,
      {},
      {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      }
    )
    .then((res) => {
      if (res.data.status = "OK") {
        localStorage.setItem("ssoToken", res.data.data.ssoToken);
        localStorage.setItem("VoiceStatuslastApiCallTime", Date.now());
        //window.location.reload(true);
        setTimeout(() => {
          window.location.reload(true);
        }, 500);
       
       
      } 
    })
  }
  const portalLinkOnclick = async () => {
    await axios
      .post(
        PortalUrl + "/v1/purple/portallink",
        {},
        {
          headers: {
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setPortalLinkList(res.data.data);
        } else {
          setPortalLinkList({});
        }
      })
      .catch((err) => {
        console.log("portallink", err);
      });
  };
  useEffect(() => {
    JSON.parse(localStorage.getItem("tokenAgent")).channel.map((item) => {
      if (item.channelName == "Voice") {
        props.setVoiceAvailable(true);
      }
    });
  }, []);
  const forceLogout = async () => {
    const agent = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + `/users/logout/${agent.user_id}`,
        {
          type: "forcelogout",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then(async (res) => {
        if (res.data.success == true) {
          const getTenantId = await localStorage.getItem("TenantId");
          localStorage.clear();
          if (!getTenantId) {
            navigate("/");
            localStorage.setItem("TenantId", getTenantId);
          } else {
            const loginUrl = `${localStorage.getItem("frontendBaseURL")}?tenantID=${getTenantId}`;
            localStorage.setItem("TenantId", getTenantId);
            window.location.href = loginUrl;
          }
        } else {
          toast.warn("Please Close all Active Sessions", toaststyle);
        }
      })
      .catch((err) => {
        console.log("LogoutAgent", err);
      });
  };
  useEffect(() => {
    let timeout;
    const resetTimeout = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        setIsActive(false);
      }, logoutTime);
    };

    const handleUserActivity = () => {
      setIsActive(true);
      resetTimeout();
    };

    resetTimeout();
    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    return () => {
      clearTimeout(timeout);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, []);
  useEffect(() => {
    if (!isActive) {
      forceLogout();
    }
  }, [isActive]);
  useEffect(() => {
    if (
      props.voiceAvailable &&
      (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS")
    ) {
      const checkApiCall = () => {
        const lastCallTimestamp = localStorage.getItem(
          "VoiceStatuslastApiCallTime"
        );
        const currentTime = Date.now();
        const oneHour = 105 * 60 * 1000;
        // const oneHour = 10 * 60 * 1000;
        // const oneHour = 1 * 60 * 1000;

        if (!lastCallTimestamp || currentTime - lastCallTimestamp >= oneHour) {
          let getCurrentStatus = localStorage.getItem("AgentStatus");
          if (getCurrentStatus != "InCall" && getCurrentStatus != "Connected") {
            console.log(
              "%c🚀 Voice status API call triggered after 1hr! 🚀",
              "color: #fff; background: #175ab6; font-size: 14px; padding: 4px 8px; border-radius: 4px;"
            );
           // changeStatusVoice(getCurrentStatus, getCurrentStatus);
           voicelogin()
          }
        }
      };
      checkApiCall();
      var interval = setInterval(checkApiCall, 60000);
    }
    return () => {
      clearInterval(interval);
    };
  }, []);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [anchorEl2, setAnchorEl2] = useState(null);
  const handleClick2 = (event) => {
    if (props.callList.length == 0) {
      setAnchorEl2(event.currentTarget);
    }
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  const open2 = Boolean(anchorEl2);
  const id2 = open2 ? "simple-popover" : undefined;

  const LogoutAesLiteAgent = () => {
    const agentLoginId = JSON.parse(localStorage.getItem("tokenAgent"));
    if (props.voicePlatForm == "AES" && agentLoginId.role == "Agent") {
      const AgentLogoutStatus = {
        Event: "AgentState",
        Extension: JSON.parse(localStorage.getItem("AvayaUsername")),
        Agentname: agentLoginId.voiceRecord.avayaLoginId
          ? agentLoginId.voiceRecord.avayaLoginId
          : null,
        AgentPassword: JSON.parse(localStorage.getItem("AvayaPassword")),
        AgentReason: "Log Out",
        AgentWorkmode: "Manual In",
        AcdGroup: "681",
      };
      aesSocket.send(JSON.stringify(AgentLogoutStatus));
    }
  };
  const UnRegisterExten = () => {
    const UnregisterReg = {
      Event: "UnSubScribe",
      Extension: JSON.parse(localStorage.getItem("AvayaUsername")),
    };
    aesSocket.send(JSON.stringify(UnregisterReg));
  };

  const logout = async () => {
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    let userID = data.user_id;
    if (data) {
      await axios
        .post(
          BaseUrl + "/users/logoutnew/" + userID,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.success == true) {
            localStorage.removeItem("AvayaUsername");
            localStorage.removeItem("tab");
            localStorage.removeItem("timer_connect_sec");
            localStorage.removeItem("AvayaPassword");
            localStorage.removeItem("AvayaDomain");
            localStorage.removeItem("client");
            localStorage.removeItem("statusValue");
            localStorage.removeItem("emailDisplay");
            localStorage.removeItem("timer_connect_min");
            localStorage.removeItem("tokenAgent");
            localStorage.removeItem("timer_status");
            localStorage.removeItem("NameDisplay");
            localStorage.removeItem("access_token");
            localStorage.removeItem("timer_connect_hour");
            localStorage.removeItem("EnableWEBRTC");
            localStorage.removeItem("ticketcrm");
            localStorage.removeItem("AgentStatus");
            if (!localStorage.getItem("TenantId")) {
              window.location.href = "error.html";
            } else {
              const loginUrl = `${localStorage.getItem("frontendBaseURL")}?tenantID=${encodeURIComponent(
                localStorage.getItem("TenantId")
              )}`;
              window.location.href = loginUrl;
            }
            navigate("/");
          } else {
            toast.warn("Please Close all Active Sessions", toaststyle);
          }
        })
        .catch((err) => {});
    }
  };

  const loginbyDomain = async () => {
    if (
      props.voiceAvailable &&
      (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS")
    ) {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/login?username=${localStorage.getItem(
              "AvayaUsername"
            )}&password=${localStorage.getItem(
              "AvayaPassword"
            )}&domain=${localStorage.getItem("AvayaDomain")}`,
          {},
          {
            headers: {
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            localStorage.setItem("ssoToken", res.data.data.ssoToken);
            localStorage.setItem(
              "agentLoginTerminalId",
              res.data.data.agents[0].agentLoginId
            );
            localStorage.setItem(
              "agentUsername",
              res.data.data.agents[0].agentUsername
            );
            loginbyDomainforAgent(
              res.data.data.agents[0].agentLoginId,
              res.data.data.ssoToken,
              res.data.data.agents[0].agentUsername
            );
          } else {
            let data = await JSON.parse(localStorage.getItem("tokenAgent"));
            await axios
              .post(
                BaseUrl + "/users/updateAgentStatus/",
                {
                  status: "Ready",
                  userId: data.user_id,
                },
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                }
              )
              .then((res) => {
                if (res.data.status) {
                  setgoReadyButtonDisable(false);
                  props.setShowingStatus("Ready");
                  localStorage.setItem("AgentStatus", "Ready");
                  props.setShowingStatusClass("showStatus");
                  props.setShowingStatusVoice("Not Connected");
                  props.setReadyButton(true);
                  setspinner("");
                } else {
                  setgoReadyButtonDisable(false);
                  props.setShowingStatus("Connected");
                  localStorage.setItem("AgentStatus", "Connected");
                  props.setShowingStatusClass("showStatusConnected");
                  props.setShowingStatusVoice("Connected");
                  props.setReadyButton(false);
                  toast.warn("Please Try Again After Some Time", toaststyle);
                  ErrorNotification("Voice LogIn", res.data.message);
                  setspinner("");
                }
              })
              .catch((err) => {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", toaststyle);
                ErrorNotification("Voice LogIn", err);
                setspinner("");
              });
          }
        })
        .catch(async (error) => {
          ErrorNotification("Voice LogIn", "");
          let data = await JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Not Connected");
                props.setReadyButton(true);
                setspinner("");
              } else {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", toaststyle);
                setspinner("");
              }
            })
            .catch((err) => {
              setgoReadyButtonDisable(false);
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
              toast.warn("Please Try Again After Some Time", toaststyle);
            });
        });
    } else {
      updateStatus("Ready");
    }
  };
  const loginbyDomainforAgent = async (terminalId, ssoToken, agentUsername) => {
    if (!terminalId && !ssoToken) return;
    await axios
      .post(
        AvcUrl +
          `/voice/cct/agent/${terminalId}/login/${terminalId}?status=Ready`,
        {},
        {
          headers: {
            ssoToken: ssoToken,
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then(async (res) => {
        if ((res.data.status = "OK")) {
          localStorage.setItem("VoiceStatuslastApiCallTime", Date.now());
          let data = JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
                agentLoginTerminalId: terminalId,
                agentUsername: agentUsername,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Ready");
                setspinner("");
                props.setReadyButton(true);
                setTimeout(() => {
                  window.location.reload(true);
                }, 500);
              } else {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                setspinner("");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", toaststyle);
              }
            })
            .catch((err) => {
              setgoReadyButtonDisable(false);
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              setspinner("");
              props.setReadyButton(false);
              toast.warn("Please Try Again After Some Time", toaststyle);
            });
        } else {
          updateStatus("Ready");
          props.setShowingStatusVoice("Not Connected");
          setspinner("");
          ErrorNotification("Voice LogIn", res.data.message);
        }
      })
      .catch((error) => {
        updateStatus("Ready");
        props.setShowingStatusVoice("Not Connected");
        ErrorNotification("Voice LogIn", error.message);
      });
  };
  const logoutByDomainFirst = async () => {
    if (
      props.voiceAvailable &&
      (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS")
    ) {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId"
            )}/logout/${localStorage.getItem("agentLoginTerminalId")}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            logoutByDomainSecond();
          } else {
            setgoReadyButtonDisable(false);
            updateStatus("Connected");
            ErrorNotification("Voice LogOut", res.data.message);
          }
        })
        .catch((error) => {
          setgoReadyButtonDisable(false);
          updateStatus("Connected");
          ErrorNotification("Voice LogOut", error.message);
        });
    } else {
      updateStatus("Connected");
    }
  };
  const logoutByDomainSecond = async () => {
    const agentUsername = localStorage.getItem("agentUsername");
    await axios
      .post(
        AvcUrl + "/voice/cct/logout?username=" + agentUsername,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          setgoReadyButtonDisable(false);
          updateStatus("Connected");
          // setTimeout(() => {
          //   window.location.reload(true);
          // }, 500);
        } else {
          setgoReadyButtonDisable(false);
          updateStatus("Connected");
          ErrorNotification("Voice LogOut", res.data.message);
        }
      })
      .catch((err) => {
        setgoReadyButtonDisable(false);
        updateStatus("Connected");
        ErrorNotification("Voice LogOut", err.message);
      });
  };
  const liteStatusChange = (reason) => {
    const agent = JSON.parse(localStorage.getItem("tokenAgent"));
    if (props.voicePlatForm == "AES" && agent.role == "Agent") {
      const extensionNum = JSON.parse(localStorage.getItem("AvayaUsername"));
      const extensionPass = JSON.parse(localStorage.getItem("AvayaPassword"));
      var RegDetails = {
        Event: "AgentState",
        Extension: extensionNum,
        Agentname: agent.voiceRecord.avayaLoginId,
        AgentPassword: extensionPass,
        AgentReason: reason,
        AgentWorkmode: "Manual In",
        AcdGroup: "681",
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const updateStatus = async (value, value2) => {
    if (!value) return;
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setgoReadyButtonDisable(false);
        if (res.data.status) {
          if (value == "Connected") {
            if (props.voicePlatForm == "ACR" || props.voicePlatForm == "AES") {
              setgoReadyButtonDisable(false);
              props.setShowingStatus(value);
              localStorage.setItem("AgentStatus", value);
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
              return;
            }
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatusConnected");
            props.setShowingStatusVoice("Connected");
            localStorage.removeItem("ssoToken");
            localStorage.removeItem("agentLoginTerminalId");
            localStorage.removeItem("agentUsername");
            localStorage.removeItem("statusValue");
            props.setReadyButton(false);
          } else if (value == "Ready") {
            if (props.voicePlatForm == "ACR" || props.voicePlatForm == "AES") {
              setgoReadyButtonDisable(false);
              props.setShowingStatus("Ready");
              localStorage.setItem("AgentStatus", "Ready");
              props.setShowingStatusClass("showStatus");
              props.setShowingStatusVoice("Ready");
              props.setReadyButton(true);
              props.setShowingStatusVoice("Ready");
              if (value2 == "reloadOneTime" && !isAesReadyReload) {
                setTimeout(() => {
                  window.location.reload(true);
                }, 500);
              }
              return;
            }

            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatus");
            if (showingStatusVoice == "Not Connected") {
            } else {
              changeStatusVoice("Ready", "Ready");
            }
          } else {
            if (props.voicePlatForm == "ACR" || props.voicePlatForm == "AES") {
              setgoReadyButtonDisable(false);
              props.setShowingStatus(value);
              localStorage.setItem("AgentStatus", value);
              props.setShowingStatusClass("showStatusRed");
              props.setShowingStatusVoice("Not Ready");
              props.setReadyButton(true);
              return;
            }
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatusRed");
            if (showingStatusVoice == "Not Connected") {
            } else {
              if (value == "Not Ready") {
                changeStatusVoice("Not Ready", "Not Ready");
              }
            }
          }
        }
      })
      .catch((err) => {
        setgoReadyButtonDisable(false);
      });
  };
  const changeStatusVoice = async (status, value2) => {
    if (
      props.voiceAvailable &&
      (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS")
    ) {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId"
            )}/status?status=${status}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken")
                ? localStorage.getItem("ssoToken")
                : "",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("VoiceStatuslastApiCallTime", Date.now());
            props.setShowingStatusVoice(value2);
            if (status == "Ready") {
              localStorage.removeItem("VoiceActivate");
            }
          } else {
            ErrorNotification("Voice Status", res.data.message);
            props.setShowingStatusVoice("Not Connected");
          }
        })
        .catch((error) => {
          ErrorNotification("Voice Status", error.message);
          props.setShowingStatusVoice("Not Connected");
        });
    }
  };
  const updateStatusWithReasonCode = async (value) => {
    if (
      props.voiceAvailable &&
      (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS")
    ) {
      if (!value) return;
      await axios
        .post(
          AvcUrl +
            `/voice/cct/changeAgentStatusReasonCode?agentId=${localStorage.getItem(
              "agentLoginTerminalId"
            )}&status=Not Ready&reason=${
              value.statusCode == null ? "" : value.statusCode
            }`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const userStatus = async () => {
    await axios
      .post(
        BaseUrl + "/userstatus/userstatuslist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setUserstatus(res.data.data);
        } else {
          setUserstatus([]);
        }
      });
  };
  const ErrorNotification = (headerMsg, msg) => {
    const randomChars = Math.random().toString(36).substring(2, 10);
    const timestamp = new Date().getTime().toString(36);
    const randomId = randomChars + timestamp;
    var newNotification = {
      id: randomId,
      username: headerMsg,
      client_msg: msg,
      from_id: "voice api",
      chatType: "Error Message",
    };
    props.updateNotification(newNotification);
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: "white",
        height: "48px",
      }}
    >
      <Toolbar
        sx={{
          "@media screen and (min-width: 600px)": {
            minHeight: "48px",
            padding: 0,
          },
          "@media screen and (min-width: 0px)": {
            minHeight: "48px",
            padding: 0,
          },
        }}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%", height: "100%" }}
        >
          <Box
            sx={{
              paddingLeft: "10px",
              height: "100%",
              width: "35vw",
              display: "flex",
              position: "relative",
              overflow: "hidden",
              fontSize: "18px",
            }}
          >
            <div className="navuser"></div>
            <Stack
              spacing={1}
              direction={"row"}
              alignItems={"center"}
              sx={{ zIndex: 9 }}
            >
              <img src={logo} alt="" style={{ width: "1.8em" }} />
              <Stack sx={{ height: "100%" }} justifyContent={"center"}>
                <Typography
                  variant="h6"
                  noWrap
                  sx={{
                    fontWeight: 600,
                    maxWidth: "290px",
                    fontSize: "1.1vw",
                  }}
                >
                  Welcome {userName.username ? userName.username : ""}
                </Typography>
                <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.85vw",
                      color: "white",
                    }}
                  >
                    LLO : {moment(LoggedInAgent.updatedAt).format("L")}
                    <span className="mx-2">
                      {moment(LoggedInAgent.updatedAt).format("hh:mm:ss A")}
                    </span>
                  </Typography>
                  <Chip
                    size="small"
                    label={props.showingStatus}
                    color={
                      props.showingStatus == "Ready"
                        ? "success"
                        : props.showingStatus == "Connected"
                          ? "primary"
                          : "error"
                    }
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.7vw",
                      height: "17px",
                      display: "flex",
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Box>

          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
            sx={{ paddingRight: "10px" }}
          >
            {permission.map((module) => {
              if (module.moduleName === "NAVBAR") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "PORTAL_LINK" && item.read && item.write
                );

                if (value) {
                  return (
                    <Tooltip title="Customer Portal" arrow placement="top">
                      <IconButton
                        sx={{ color: "black", mr: " 2px" }}
                        onClick={() => {
                          handleShowportal();
                          portalLinkOnclick();
                        }}
                      >
                        <IoIosLink size={18} color="#707070" />
                      </IconButton>
                    </Tooltip>
                  );
                } else {
                  return (
                    <Tooltip title="Contact Admin" arrow placement="top">
                      <IconButton sx={{ color: "black", mr: " 2px" }}>
                        <IoIosLink size={18} color="#707070" />
                      </IconButton>
                    </Tooltip>
                  );
                }
              }
            })}

            {props.voiceAvailable && (
              <IconButton
                sx={{
                  color: "black",
                }}
                onClick={() => {
                  if (localStorage.getItem("AgentStatus") == "Connected") {
                    return;
                  } else {
                    if (props.callList.length == 0) {
                      props.setshowphonedialer(!props.showphonedialer);
                      props.setDialedNumber("");
                    }
                  }
                }}
              >
                <Numpad color="#707070" size={18} weight="bold" />
              </IconButton>
            )}

            {permission.map((module) => {
              if (module.moduleName === "NAVBAR") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "EMAIL_COMPOSE" && item.read && item.write
                );

                if (value) {
                  return (
                    <Tooltip title="New Email" arrow placement="top">
                      <IconButton
                        sx={{ color: "black", mr: " 2px" }}
                        onClick={() => {
                          props.setshowComposeMail(!props.showComposeMail);
                          document.title = "Inaipi-Digital - Compose-Email";
                        }}
                      >
                        <EnvelopeSimple size={18} color="#707070" />
                      </IconButton>
                    </Tooltip>
                  );
                } else {
                  return (
                    <Tooltip title="Contact Admin" arrow placement="top">
                      <IconButton sx={{ color: "black", mr: " 2px" }}>
                        <EnvelopeSimple size={18} color="#707070" />
                      </IconButton>
                    </Tooltip>
                  );
                }
              }
            })}

            <>
              {/* Notification */}
              {permission.map((module, index) => {
                if (module.moduleName === "NAVBAR") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "NOTIFICATION" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    return (
                      <Tooltip
                        title="Notification"
                        arrow
                        placement="top"
                        key={index}
                      >
                        <IconButton
                          sx={{ color: "black", mr: " 2px" }}
                          aria-describedby={id}
                          onClick={handleClick}
                        >
                          <StyledBadge
                            badgeContent={props.notification.length}
                            sx={{
                              ".MuiBadge-badge": {
                                background: "#DB3240",
                                color: "white",
                              },
                            }}
                          >
                            <Bell color="#707070" size={18} />
                          </StyledBadge>
                        </IconButton>
                      </Tooltip>
                    );
                  } else {
                    return (
                      <Tooltip
                        title="Contact Admin"
                        arrow
                        placement="top"
                        key={index}
                      >
                        <IconButton sx={{ color: "black", mr: " 2px" }}>
                          <Bell color="#707070" size={18} />
                        </IconButton>
                      </Tooltip>
                    );
                  }
                }
              })}

              <StyledPopover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{
                  zIndex: 99999,
                  ".MuiPopover-root": {
                    borderRadius: "7px",
                  },
                }}
              >
                <Box sx={{ maxHeight: "400px", width: "300px" }} p={1}>
                  <Stack spacing={3}>
                    <stack>
                      <box className="d-flex align-items-center justify-content-start">
                        <Typography
                          sx={{ fontSize: 14, fontWeight: 600 }}
                          color="text.primary"
                          gutterBottom
                        >
                          <IoNotificationsOutline className="me-1" />{" "}
                          Notifications
                        </Typography>
                      </box>
                      <CardContent
                        sx={{
                          maxHeight: "300px",
                          width: "100%",
                          overflowY: "auto",
                        }}
                        className="p-0"
                      >
                        {props.notification.length > 0 ? (
                          props.notification
                            .slice(0)
                            .reverse()
                            .map((data, index) => {
                              return (
                                <Box
                                  key={index}
                                  sx={{
                                    height: "auto",
                                    borderBottom: "2px #d4d4d4 solid",
                                    cursor: "pointer",
                                    marginBottom: "4px",
                                    border: "1px solid #d5d5d5",
                                    borderRadius: "5px",
                                  }}
                                  p={1}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                  >
                                    <Stack
                                      direction={"row"}
                                      alignItems={"center"}
                                      spacing={0.8}
                                    >
                                      <Avatar
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: 600,
                                          height: "33px",
                                          width: "33px",
                                          background: "#0B3363",
                                        }}
                                      >
                                        {data.username
                                          ? data.username
                                              .slice(0, 2)
                                              .toUpperCase()
                                          : ""}
                                      </Avatar>

                                      <Stack spacing={0.1}>
                                        <Stack
                                          direction={"row"}
                                          alignItems={"center"}
                                        >
                                          <Typography
                                            noWrap
                                            variant="subtitle2"
                                            sx={{
                                              fontWeight: 600,
                                              fontSize: "13px",
                                              width: "200px",
                                            }}
                                          >
                                            {data.username == "smartx"
                                              ? ""
                                              : data.username}{" "}
                                            {data.chatType
                                              ? `(${data.chatType})`
                                              : ""}
                                          </Typography>
                                        </Stack>
                                        <Stack>
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              fontSize: "9px",
                                              width: "160px",
                                              height: "auto",
                                            }}
                                          >
                                            {data.client_msg}
                                          </Typography>
                                        </Stack>
                                      </Stack>
                                    </Stack>

                                    <Stack
                                      alignItems={"center"}
                                      justifyContent={"center"}
                                    >
                                      <Typography
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "7px",
                                        }}
                                        variant="caption"
                                      >
                                        {data.msg_time}
                                      </Typography>
                                      <IconButton
                                        onClick={() => {
                                          props.closeNotify(
                                            data.id,
                                            props.notification
                                          );
                                        }}
                                      ></IconButton>
                                    </Stack>
                                  </Stack>
                                </Box>
                              );
                            })
                        ) : (
                          // No notifications
                          <Box
                            className="d-flex align-items-center justify-content-center"
                            sx={{
                              background: "#f3f6fc",
                              borderRadius: "4px",
                              minHeight: "100px",
                              padding: 0,
                            }}
                          >
                            <box className="d-flex align-items-center">
                              <Typography
                                sx={{ fontSize: 14, fontWeight: 600 }}
                                color="text.secondary"
                                gutterBottom
                              >
                                <IoNotificationsOffOutline className="me-2" />{" "}
                                No notifications yet
                              </Typography>
                            </box>
                          </Box>
                        )}
                      </CardContent>
                      <CardActions
                        sx={{ padding: 0 }}
                        className="mt-2 d-flex align-items-center justify-content-center"
                      >
                        <Button
                          size="small"
                          onClick={() => {
                            props.clearnotifyAll();
                          }}
                          disabled={
                            props.notification.length == 0 ? true : false
                          }
                          className="w-100"
                          sx={{ textTransform: "capitalize" }}
                        >
                          Clear All
                        </Button>
                      </CardActions>
                    </stack>
                  </Stack>
                </Box>
              </StyledPopover>
            </>

            <>
              {/* user details  */}
              <Avatar
                aria-describedby={id2}
                onClick={handleClick2}
                sx={{
                  background:
                    "linear-gradient(180deg, #0b3363, rgb(62, 168, 234) 100%)",
                  height: "30px",
                  width: "30px",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {getUserNameOnNavbar()}
              </Avatar>

              <StyledPopover
                id={id2}
                open={open2}
                anchorEl={anchorEl2}
                onClose={handleClose2}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{ zIndex: 99999 }}
              >
                {!showReasonCode && (
                  <Box sx={{ height: "max-content", width: "350px" }} p={2}>
                    <Stack sx={{ height: "100%" }} spacing={1.5}>
                      <Stack spacing={1} sx={{ flexGrow: 1 }}>
                        <Box
                          sx={{
                            height: "max-content",
                            width: "100%",
                            borderRadius: "7px",
                            background: "rgba( 14, 71, 140, 0.75 )",
                            boxShadow: "0 8px 32px 0 rgba( 31, 38, 135, 0.37 )",
                            backdropFilter: "blur( 15.5px )",
                            webkitBackdropFilter: "blur(16px) saturate(180%)",
                          }}
                          p={1}
                        >
                          <Stack
                            direction={"row"}
                            justifyContent={"space-evenly"}
                            alignItems={"center"}
                            sx={{ width: "100%" }}
                          >
                            <Stack
                              alignItems={"center"}
                              spacing={1}
                              direction={"row"}
                            >
                              <Avatar
                                sx={{
                                  background: "rgb(2,0,36)",
                                  background:
                                    "linear-gradient(180deg, #0b3363, rgb(62, 168, 234) 100%)",
                                  height: "50px",
                                  width: "50px",
                                  fontSize: "16px",
                                  fontWeight: 600,
                                }}
                              >
                                {getUserNameOnNavbar().toUpperCase()}
                              </Avatar>
                              <Stack spacing={0.2} sx={{ width: "100%" }}>
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  spacing={0.2}
                                  sx={{ width: "100%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "1vw",
                                      color: "white",
                                    }}
                                    spacing={1}
                                    className="me-1"
                                  >
                                    Agent ID :
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "1vw",
                                      width: "155px",
                                      color: "white",
                                    }}
                                    noWrap
                                  >
                                    {getEmailOnNavbar()}
                                  </Typography>
                                </Stack>

                                {permission.map((module, index) => {
                                  if (module.moduleName === "NAVBAR") {
                                    const value = module.screen.find(
                                      (item) =>
                                        item.screenId == "UPDATE_PASSWORD" &&
                                        item.read &&
                                        item.write
                                    );

                                    if (value) {
                                      return (
                                        <Typography
                                          key={index}
                                          className="d-flex align-items-center"
                                          sx={{
                                            fontWeight: 400,
                                            fontSize: "12px",
                                            width: "155px",
                                            cursor: "pointer",
                                            color: "white",
                                            "&:hover": {
                                              textDecoration: "underline",
                                            },
                                          }}
                                          onClick={() => {
                                            setAnchorEl2(false);
                                            setopenChangePasswordModel(true);
                                          }}
                                        >
                                          <RiLockPasswordFill className="me-2 fs-11" />
                                          Change Password
                                        </Typography>
                                      );
                                    } else {
                                      return <></>;
                                    }
                                  }
                                })}
                              </Stack>
                            </Stack>

                            <IconButton
                              sx={{ padding: "5px" }}
                              onClick={handleClose2}
                            ></IconButton>
                          </Stack>
                        </Box>

                        {readyButton == false ? (
                          <Button
                            sx={{
                              boxShadow: "none",
                              minHeight: "40px",
                              "&:hover": {
                                boxShadow: "none",
                              },
                            }}
                            variant="contained"
                            color="success"
                            startIcon={<PersonSimpleRun size={20} />}
                            onClick={() => {
                              if (
                                props.voicePlatForm == "ACR" ||
                                props.voicePlatForm == "AES"
                              ) {
                                updateStatus("Ready", "reloadOneTime");
                              } else {
                                loginbyDomain();
                                setgoReadyButtonDisable(true);
                              }
                            }}
                            disabled={goReadyButtonDisable}
                          >
                            Go Ready
                          </Button>
                        ) : (
                          <>
                            <Button
                              sx={{
                                boxShadow: "none",
                                minHeight: "40px",
                                "&:hover": {
                                  boxShadow: "none",
                                },
                              }}
                              color="error"
                              variant="contained"
                              startIcon={<MdFileDownloadDone size={22} />}
                              onClick={() => {
                                logoutByDomainFirst();
                                setgoReadyButtonDisable(true);
                              }}
                              disabled={goReadyButtonDisable}
                            >
                              Finish Work
                            </Button>

                            <Stack
                              spacing={0.5}
                              sx={{
                                background: "#f3f6fc",
                                borderRadius: "7px",
                              }}
                              p={1}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "13px",
                                  color: "#0b3363",
                                }}
                              >
                                Status
                              </Typography>
                              <Item
                                onClick={() => {
                                  userStatus();
                                  setshowReasonCode(true);
                                }}
                                sx={{ minHeight: "35px" }}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  sx={{ width: "100%" }}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                    spacing={1}
                                    sx={{ width: "100%" }}
                                  >
                                    <Stack
                                      direction={"row"}
                                      alignItems={"center"}
                                      spacing={1}
                                    >
                                      <TbUserExclamation
                                        size={18}
                                        weight="bold"
                                      />
                                      <Typography
                                        sx={{
                                          fontSize: "13px",
                                        }}
                                      >
                                        Not Ready With Reason...
                                      </Typography>
                                    </Stack>

                                    <CaretRight size={18} weight="bold" />
                                  </Stack>
                                </Stack>
                              </Item>
                              <Item
                                onClick={() => {
                                  updateStatus("Ready", "reloadOneTime");
                                  liteStatusChange("Ready");
                                  localStorage.setItem(
                                    "VoiceCallStatus",
                                    "Ready"
                                  );
                                }}
                                sx={{ minHeight: "35px" }}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    spacing={1}
                                  >
                                    <TbUserCheck size={18} weight="bold" />
                                    <Typography
                                      sx={{
                                        fontSize: "0.875rem",
                                      }}
                                    >
                                      Go Ready
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </Item>
                              <Item
                                onClick={() => {
                                  updateStatus("Not Ready");
                                  liteStatusChange("Not Ready");
                                  localStorage.setItem(
                                    "VoiceCallStatus",
                                    "Not Ready"
                                  );
                                }}
                                sx={{ minHeight: "35px" }}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    spacing={1}
                                  >
                                    <TbSquareRoundedX size={18} weight="bold" />
                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                      }}
                                    >
                                      Go Not Ready
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </Item>
                            </Stack>
                          </>
                        )}
                      </Stack>

                      <Stack spacing={1}>
                        <Stack
                          spacing={0.5}
                          sx={{ background: "#f3f6fc", borderRadius: "7px" }}
                          p={1}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "13px",
                              color: "#0b3363",
                            }}
                          >
                            Channel
                          </Typography>
                          {JSON.parse(
                            localStorage.getItem("tokenAgent")
                          ).channel.map((item) => {
                            return (
                              <Item
                                key={item.channelId}
                                sx={{
                                  minHeight: "35px",
                                  transition: "none",
                                  cursor: "pointer",
                                  "&.MuiPaper-root": {
                                    "&:hover": {
                                      background: "#1473e6",
                                      color: "white",
                                    },
                                  },
                                }}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  sx={{ width: "100%" }}
                                >
                                  {`${item.channelName} - ${item.channelName == "Voice" ? showingStatusVoice : showingStatus}`}
                                  {item.channelName == "Voice" &&
                                  readyButton &&
                                  showingStatusVoice == "Not Connected" ? (
                                    <ArrowsClockwise
                                      size={17}
                                      style={{ animation: spinner }}
                                      onClick={() => {
                                        if (props.voicePlatForm == "ACR") {
                                          setspinner("spin 1s infinite");
                                          updateStatus(
                                            "Ready",
                                            "reloadOneTime"
                                          );
                                        } else {
                                          setspinner("spin 1s infinite");
                                          loginbyDomain();
                                        }
                                      }}
                                    />
                                  ) : null}
                                </Stack>
                              </Item>
                            );
                          })}
                        </Stack>
                        <Button
                          disableRipple
                          variant="plain"
                          size="small"
                          startIcon={<SealCheck size={12} />}
                          sx={{
                            fontSize: "12px",
                            "&:hover": { background: "none" },
                            userSelect: "none",
                            cursor: "none",
                          }}
                        >
                          {`Version : ${versionCode}`}
                        </Button>
                        <Divider />

                        {readyButton == false && (
                          <Button
                            sx={{
                              boxShadow: "none",
                              "&:hover": {
                                boxShadow: "none",
                              },
                            }}
                            color="error"
                            variant="text"
                            startIcon={<SignOut size={15} />}
                            onClick={logout}
                          >
                            SIGN OUT
                          </Button>
                        )}
                      </Stack>
                    </Stack>
                  </Box>
                )}

                {showReasonCode && (
                  <Slide in={showReasonCode} direction="left">
                    <Box sx={{ height: "500px", width: "350px" }} p={2}>
                      <Stack spacing={1}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          sx={{ background: "#f3f6fc", borderRadius: "7px" }}
                          p={1}
                        >
                          <Typography
                            sx={{
                              flexGrow: 1,
                              fontSize: "0.999rem",
                              color: "#0b3363",
                              fontWeight: 600,
                            }}
                            variant="subtitle1"
                          >
                            Reason Code
                          </Typography>
                          <IconButton
                            sx={{ padding: "5px" }}
                            onClick={() => {
                              setshowReasonCode(false);
                            }}
                          >
                            <IoArrowBack size={18} weight="bold" />
                          </IconButton>
                        </Stack>

                        <Box
                          className="CONTACT-LIST-AREA"
                          sx={{
                            height: "400px",
                            overflowY: "scroll",
                            background: "#f3f6fc",
                            borderRadius: "7px",
                          }}
                          p={1}
                        >
                          <Stack spacing={0.5}>
                            {userstatus.map((item, index) => (
                              <Item
                                sx={{ minHeight: "35px" }}
                                key={index}
                                onClick={() => {
                                  localStorage.setItem(
                                    "VoiceCallStatus",
                                    item.statusName
                                  );
                                  updateStatus(item.statusName);
                                  liteStatusChange("Not Ready");
                                  updateStatusWithReasonCode(item);
                                  setshowReasonCode(false);
                                }}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    spacing={1}
                                  >
                                    <TbCircleDotFilled
                                      size={14}
                                      weight="bold"
                                    />
                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                      }}
                                    >
                                      {item.statusName}
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </Item>
                            ))}
                          </Stack>
                        </Box>
                      </Stack>
                    </Box>
                  </Slide>
                )}
              </StyledPopover>
            </>
          </Stack>
        </Stack>
      </Toolbar>

      {openChangePasswordModel && (
        <ChangesPasswordModel
          OpenDialog={openChangePasswordModel}
          handleClose={() => {
            setopenChangePasswordModel(false);
          }}
        />
      )}

      <Modal show={showportallink} onHide={handleCloseportal} size="sm">
        <Modal.Header style={{ backgroundColor: "#0b3364", height: "40px" }}>
          <div
            className="w-100 d-flex justify-content-between align-items-center text-white"
            style={{ fontSize: "12px" }}
          >
            PORTAL LINKS
            <AiFillCloseCircle
              onClick={handleCloseportal}
              style={{ cursor: "pointer" }}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid w-100">
            {getPortalLinksVal.map((items) => (
              <div className="d-flex w-100">
                <Card
                  style={{
                    height: "30px",
                    width: "20vw",
                    fontSize: "12px",
                    backgroundColor:
                      hoveredCard === items.hoverCard ? "#e0e0e0" : "#fff",
                    cursor: "pointer",
                  }}
                  className="mx-auto"
                  onClick={() => window.open(items.url)}
                  onMouseEnter={() => setHoveredCard(items.hoverCard)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <span className="d-flex justify-content-center align-items-center my-auto h-100 text-decoration-none link_hover">
                    {items.title}
                  </span>
                </Card>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </AppBar>
  );
};

export default connect(mapStateToProps, {
  closeNotify,
  clearnotifyAll,
  setshowphonedialer,
  setShowingStatusClass,
  setShowingStatus,
  setShowingStatusVoice,
  setReadyButton,
  updateNotification,
  setVoiceAvailable,
})(Navbar);
